import type { IconProps } from '../types/IconProps.ts';
export const Video: IconProps = {
    name: 'Video',
    children: [
        `<rect width="14" height="12" x="2" y="6" rx="1" />`,
        `<path d="m16 13 4.45 2.96a1 1 0 0 0 1.55-.83V8.87a1 1 0 0 0-1.55-.83L16 11" />`,
    ]
};